import { attachToDebug } from '@/util/debug';

// Not using version number from package.json in order to save 5kb bundle size
export const version = '2.0.0';

attachToDebug('version', version);
